<template>
    <div class="filter-container">
        <slot></slot>
    </div>
</template>

<script>
export default {
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
